<template>
  <v-select
    class="organization__select"
    v-model="organizationId"
    hide-details
    placeholder="Organization"
    :items="organizationsToShow"
    :menu-props="{
      offsetY: true,
      nudgeBottom: -3,
    }"
    @change="organizationChanged"></v-select>
</template>

<script>
  import { computed } from "@vue/composition-api";
  import { useRouter } from "@core/utils";
  import store from "@/store";
  import isEmpty from "lodash/isEmpty";

  export default {
    setup(props, context) {
      const { route, router } = useRouter();

      let organizationId = computed({
        get() {
          if (!isEmpty(store.getters["getActiveOrganization"])) {
            return store.getters["getActiveOrganization"].organization.id;
          }

          return false;
        },
        set(newVal) {
          const chosenOrganization = findOrganizationById(newVal);
          store.dispatch("setActiveOrganization", chosenOrganization);
          store.dispatch("updateAbilities");
          store.dispatch("api/refresh", route.value);
        },
      });

      const userOrganizations = computed(() => store.getters["getUserOrganizations"]);

      const findOrganizationById = id => {
        return userOrganizations.value.find(obj => {
          return obj.organization.id === id;
        });
      };

      const parseMultipleUserOrganizations = () => {
        // we have to map the object to fit v-select API
        return userOrganizations.value.map(row => {
          return parseSingleUserOrganization(row);
        });
      };

      const parseSingleUserOrganization = organization => {
        return {
          text: organization.organization.name,
          value: organization.organization.id,
        };
      };

      const organizationsToShow = computed(() => {
        return parseMultipleUserOrganizations(userOrganizations.value);
      });

      const organizationChanged = () => {
        if (route.value.name.includes("dashboard")) {
          router.go(0);
        }

        if (
          (route.value.name.includes("edit") || route.value.name.includes("create")) &&
          route.value.meta.resource !== "organizations"
        ) {
          router.push({
            name: `${route.value.meta.resource}_list`,
          });
        }
      };

      return {
        organizationsToShow,
        organizationId,
        organizationChanged,
      };
    },
  };
</script>
<style scoped lang="scss">
  @import "../@core/preset/preset/typography/index.scss";
  @import "../@core/preset/preset/functions.scss";

  .organization__select {
    &.v-select {
      // &:not(.v-input--is-disabled) > .v-input__control > .v-input__slot:hover {
      //   background-color: get-color("background") !important;
      // }
      &:not(.v-input--is-disabled) {
        &::v-deep {
          & > .v-input__control {
            & > .v-input__slot:hover {
              background-color: get-color("background") !important;
            }
          }
        }
      }

      &.v-input--is-focused {
        &::v-deep {
          & > .v-input__control > .v-input__slot {
            border-top: none !important;
            border-left: none !important;
            border-right: none !important;
            border-bottom: 1px solid get-color("border") !important;
          }
        }
      }
    }
    &::v-deep {
      .v-input__slot {
        border-radius: 0 !important;
        background-color: get-color("background") !important;
        border-top: none !important;
        border-left: none !important;
        border-right: none !important;
        border-bottom: 1px solid get-color("border") !important;
      }
    }
  }
</style>
